import { types, Instance } from 'mobx-state-tree';

const { model, string, number, union, maybeNull } = types;

export const SettingModel = model('SettingModel', {
  sectionKey: string,
  groupName: string,
  name: string,
  description: string,
  key: string,
  value: maybeNull(string),
  enabled: number,
  type: string,
  valueType: string,
  min: maybeNull(union(number, string)),
  max: maybeNull(union(number, string)),
});

export type ISettingModel = Instance<typeof SettingModel>;
